/*
 * @Author: zhuyan 
 * @Date: 2021-11-17 14:32:08 
 * 已支付-采购订单
 */

import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import { Link } from 'react-router-dom'
import { Table, Button, Alert } from 'antd'
import CorpQuanQian from '@/components/CorpQuanQian'
import FiltersForm from '@/components/FiltersForm'
import Export from '@/components/Export'
import { parseSearch, cryptoParamsIntoUrl } from '@/utils'
import Auth from '@/components/AuthMiddleware'

// 导出用：筛选条件初始值
let exporfilter = {
  corpId: [],
}

const PurchaseDone = (props) => {
  const { history, match, location } = props
  const search = parseSearch(location.search)

  const initParams = {
    corpId: 1,
    page: search.page || 1,
    limit: search.limit || 10,
  }

  const [states, setStates] = useState({
    dataSource: [], // 列表
    loading: true,
    total: 0, // 总条数
    filter: {
      types: [], // 筛选：资产类别
      payWay: [], // 筛选：付款方式
    },
    // 筛选条件：列表接口参数
    params: initParams,
  })
  const { dataSource, filter, loading, total, params } = states
  const productsRef = useRef()
  const productsRefDetail = useRef()
  const [showExport, setShowExport] = useState(false) // 汇总导出窗
  const [showExportDetail, setShowExportDetail] = useState(false) // 明细导出窗
  const [authList, setAuthList] = useState([]) // 按钮权限

  useEffect(() => {
    getList()
    const { page, limit, ...others } = params
    exporfilter = { ...others }
  }, [params])


  useEffect(() => {
    getPageAuth()
  }, [])

  // 获取列表
  const getList = () => {
    api
      .getAssetPurchaseList(params)
      .then((res) => {
        setStates((current) => ({
          ...current,
          loading: false,
          dataSource: res.list,
          total: res.count,
        }))
      })
      .catch(() => {
        setStates((current) => ({
          ...current,
          loading: false,
        }))
      })
  }

  // 获取按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then((list) => {
      setAuthList(list)
    })
  }

  // 获取下拉数据
  const getVariousSelectionList = () => {
    api.getVariousSelectionList().then((data) => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          types: data.types,
          payWay: data.payTypes,
        },
      }))
    })
  }

  // 点击选择所属公司
  const onChangeCorp = (data) => {
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...initParams,
        corpId: data.map((item) => item.id),
        page: 1,
      },
    }))
    history.replace(match.path)
  }

  // 分页点击
  const onChangeTable = (pagination, filters, sorter) => {
    const { current: page, pageSize: limit } = pagination
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...params,
        page: page,
        limit: limit,
      },
    }))
    history.replace(match.path + '?page=' + page + '&limit=' + limit)
  }

  // 点击筛选
  const onSubmit = (values) => {
    initParams.page = 1
    initParams.limit = 10
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...initParams,
        corpId: params.corpId,
        ...values,
      },
    }))
    history.replace(match.path)
  }

  // 预览/下载凭证
  const onVoucherAction = (record, download = false) => {
    api.getHost({}).then((res) => {
      if (download) {
        window.location = `${res.url}/api/fortune/File/DownPdf?id=${record.id}&type=${'PurchaseProof'}`
      } else {
        window.open(
          `${res.url}/api/fortune/File/PrevPdf?id=${record.id}&type=${'PurchaseProof'}`,
          '_blank'
        )
      }
    })
  }

  const columns = [
    {
      title: '订单编号',
      dataIndex: 'number',
      fixed: 'left',
      width: 160,
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入订单编号',
      },
    },
    {
      title: '业务编号',
      dataIndex: 'id',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入业务编号',
      },
      render: (text, record) => {
        return (
          <Link
            target='_blank'
            to={cryptoParamsIntoUrl('/asset/purchase/details', { id: record.id })}
          >
            {text}
          </Link>
        )
      },
    },
    {
      title: '资产类别',
      dataIndex: 'type',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.types.map((item) => ({
          label: item.name,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getVariousSelectionList()
          }
        },
      },
      render: (text, record) => record.typeName,
    },
    { title: '公司主体', dataIndex: 'corpName' },
    {
      title: '付款方式',
      dataIndex: 'payType',
      valueType: 'Select',
      optionFilterProp: "children",
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.payWay.map((item) => ({
          label: item.name,
          value: item.id,
        })),
        onDropdownVisibleChange: (open) => {
          if (open) {
            getVariousSelectionList()
          }
        },
      },
      render: (text, record) => record.payTypeName,
    },
    {
      title: '付款金额',
      dataIndex: 'payMoney',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入付款金额',
      },
      render: (text, record) => (+record.payMoney).toFixed(2),
    },

    {  
      title: '收款单位',
      dataIndex: 'payee',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入收款单位',
      }, 
    },
    { title: '开户行', dataIndex: 'payeeBank' },
    { title: '银行账号', dataIndex: 'payeeAccount' },
    {
      title: '申请人',
      dataIndex: 'creatorName',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入申请人',
      },
    },
    {
      title: '申请时间',
      dataIndex: 'addTime',
      valueType: 'RangePicker',
      search: {
        transform: (value) => {
          return {
            applyStart: value[0].format('YYYY-MM-DD'),
            applyEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    { title: '付款开户行', dataIndex: 'payBank' },
    { title: '付款账号', dataIndex: 'payAccountNo' },
    {
      title: '审批通过时间',
      dataIndex: 'auditTime',
      valueType: 'RangePicker',
      search: {
        transform: (value) => {
          return {
            auditStart: value[0].format('YYYY-MM-DD'),
            auditEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    {
      title: '银行支付日期',
      dataIndex: 'payTime',
    },
    {
      title: '回单归档时间',
      dataIndex: 'operateTime',
      valueType: 'RangePicker',
      search: {
        transform: (value) => {
          return {
            operateStart: value[0].format('YYYY-MM-DD'),
            operateEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    {
      title: '操作',
      key: 'oprate',
      fixed: 'right',
      width: 120,
      render: (text, record) => {
        return (
          <>
            {record.hasPrev &&
              <Button
                type='link'
                size='small'
                onClick={() => onVoucherAction(record)}
              >
                凭证预览
            </Button>
            }
            {record.hasDown &&
              <Button
                type='link'
                size='small'
                onClick={() => onVoucherAction(record, true)}
              >
                下载凭证
              </Button>
            }
          </>
        )
      },
    },
  ]

  return (
    <>
      <CorpQuanQian supra={false} defaultValue={params.corpId} onChange={onChangeCorp} part='feiyong' />
      <FiltersForm columns={columns} onSubmit={onSubmit} onReset={onSubmit} />
      <div className='line'></div>
      <div className='add-wrap'>
        <Auth auths={authList} code='detail-export'>
          <Button
            type='primary'
            title='明细导出'
            onClick={() => {
              setShowExportDetail(true)
            }}
            style={{ marginRight: 10 }}
          >
            明细导出
           </Button>
        </Auth>
        <Auth auths={authList} code='summary-export'>
          <Button
            type='primary'
            title='汇总导出'
            onClick={() => {
              setShowExport(true)
            }}
            style={{ marginRight: 10 }}
          >
            汇总导出
          </Button>
        </Auth>
      </div>
      <Alert
        className='corp-count'
        message={`总计：${total}条数据`}
        type='info'
        showIcon
      />
      <Table
        size='small'
        columns={columns}
        dataSource={dataSource}
        rowKey='id'
        loading={loading}
        className='askforleave-table'
        pagination={{
          pageSize: parseInt(params.limit),
          total: total,
          current: parseInt(params.page),
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 2500 }}
      ></Table>
      {/* 汇总导出 */}
      <Export
        show={showExport}
        onCancel={() => {
          setShowExport(false)
          productsRef.current.changeVal()
        }}
        tplUrl='getAssetPurchaseExportTpl'
        fieldsUrl='getAssetPurchaseTplItems'
        saveUrl='saveAssetPurchaseExportTpls'
        exportUrl='exportAssetPurchaseChange'
        method='export'
        parame={{
          ExportType: 'assetpurchase.export',
          ...exporfilter,
        }}
        cRef={productsRef}
      />
      {/* 明细导出 */}
      <Export
        show={showExportDetail}
        onCancel={() => {
          setShowExportDetail(false)
          productsRefDetail.current.changeVal()
        }}
        tplUrl='getAssetDetailExportTpl'
        fieldsUrl='getAssetDetailTplItems'
        saveUrl='saveAssetDetailExportTpls'
        exportUrl='exportAssetDetailChange'
        method='export'
        parame={{
          ExportType: 'assetdetail.export',
          ...exporfilter,
        }}
        cRef={productsRefDetail}
      />
    </>
  )
}

export default PurchaseDone
